import * as actionTypes from '../actionTypes';
import initialState from './initialState';

function moversReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.UPDATE_SHIPPING_AVAILABILITY:
      return { ...state, shippingInfoData: { ...state.shippingInfoData, isShippingAvailable: action.data }};
    case actionTypes.UPDATE_APPOINTMENT_DATA:
      return { ...state, appointment: action.data };
    case actionTypes.UPDATE_CART_DATA:
      return {
        ...state,
        moveServiceInfo: action.data && action.data.moveServiceInfo ? action.data.moveServiceInfo : {},
        orderDetailsView: action.data && action.data.orderDetailsView ? action.data.orderDetailsView : {},
      };
    case actionTypes.UPDATE_ERROR_INFO:
      return { ...state, errorInfo: action.errorData };
    case actionTypes.UPDATE_SUSPEND_INFO:
      return { ...state, suspendInfo: action.suspendInfo };
    case actionTypes.UPDATE_ORDER_NUMBER:
      return { ...state, orderNo: action.orderNo };
    case actionTypes.UPDATE_DISCONNECT_DATE:
      return { ...state, appointment: action.data };
    case actionTypes.STORE_MOVERS_PLANS:
      return { ...state, plans: action.payload, getAvailablePlansError: '' };
    case actionTypes.STORE_MOVERS_ALL_PLANS_DETAILS:
      return { ...state, allPlansDetails: action.payload };
    case actionTypes.COMPARE_PLAN_API_STATUS:
      return { ...state, comparePlan: action.data };
    case actionTypes.GET_MOVER_PLANS_ERROR:
      return { ...state, getAvailablePlansError: action.payload };
    case actionTypes.UPDATE_CUSTOMER_PLANS_ERROR:
      return { ...state, getUpdateCustomerPlanError: action.payload };

    case actionTypes.STORE_MOVERS_IMPORTANT_ACCOUNT_CHANGES:
      return { ...state, importantAccountChanges: action.payload };
    case actionTypes.GET_AGREEMENT_DETAILS:
      return { ...state, agreement: action.data };
    case actionTypes.STORE_MTN:
      return { ...state, mtn: action.payload };
    case actionTypes.GET_CBAND_FED_JSON_DETAILS:
      return { ...state, cbandJson: action.payload };
    case actionTypes.FCC_LABEL_ERROR:
      return {
        ...state,
        fccError: {
          errorValue: true,
          errorMessage: action.response,
        },
      };
      case 'UPDATE_ISPU_STORE_INFO': 
      return {...state, ispuStoreInfo: action.response};
    case actionTypes.FCC_LABEL_SUCCESS:
      return {
        ...state,
        fccError: {
          errorValue: false,
          errorMessage: '',
        },
        fccContentValue: action.response,
      };
    case actionTypes.RESET_DEVICE_SETUP_DATA:
      return {
        ...state,
        deviceSetupData: initialState.deviceSetupData,
      };
    case actionTypes.UPDATE_MOVE_IN_DATE:
      return {
        ...state,
        deviceSetupData: { ...state.deviceSetupData, moveInDate: action.payload },
      };
    case actionTypes.UPDATE_MOVE_OUT_DATE:
      return {
        ...state,
        deviceSetupData: { ...state.deviceSetupData, moveOutDate: action.payload, moveInDate: '' },
      };
    case actionTypes.UPDATE_DATE_ADJUSTMENT_FLAG:
      return {
        ...state,
        deviceSetupData: { ...state.deviceSetupData, dateAutoAdjusted: action.payload, adjustedDate: action.adjustedDate },
      };
    case actionTypes.SAVE_APPOINTMENT_SUCCESS:
      return { ...state, appointmentSuccess: action.response };
    case actionTypes.SAVE_APPOINTMENT_FAILURE:
      return { ...state, errorAppointment: action.response, appointmentSuccess: {} };
    case actionTypes.MOVERS_EQUIPMENT_LIST_SUCCESS:
      return { ...state, retrieveEquipmentListSuccess: { ...state.retrieveEquipmentListSuccess, equipmentListData: action.response } };
    case actionTypes.MOVERS_EQUIPMENT_LIST_FAILURE:
      return { ...state, errorRetrieveEquipmentList: action.response };
    case actionTypes.MOVERS_UPDATE_CART_SUCCESS:
      return { ...state, updatecartSuccess: action.response };
    case actionTypes.MOVERS_UPDATE_CART_FAILURE:
      return { ...state, errorUpdateCart: action.response, updatecartSuccess: {} };
    case actionTypes.UPDATE_SETUP_TYPE:
      return { ...state, deviceSetupData: { ...state.deviceSetupData, setupType: action.response } };
    case actionTypes.RESET_MOVE_DATES:
      return {
        ...state,
        deviceSetupData: { ...state.deviceSetupData, moveOutDate: '', moveInDate: '' },
      };
    case actionTypes.SHOW_SELECT_DATE_BANNER:
      return {
        ...state,
        showSelectDateBanner: action.response,
      };
    case actionTypes.UPDATE_SELECTED_SHIPPING_ADDRESS_OPTION:
      return {
        ...state,
        shippingAddressData: {
          ...state.shippingAddressData,
          selectedShippingOption: action.data,
        },
      };
    case actionTypes.UPDATE_SELECTED_SHIPPING_ADDRESS:
      return {
        ...state,
        shippingAddressData: {
          ...state.shippingAddressData,
          selectedShippingAddress: action.data,
        },
      };
    case actionTypes.UPDATE_SHIPPING_ADDRESS_VIEW:
      return {
        ...state,
        shippingAddressData: {
          ...state.shippingAddressData,
          currentView: action.data,
        },
      };
    case actionTypes.UPDATE_SHIPPING_ADDRESS_LIST:
      return {
        ...state,
        shippingAddressData: {
          ...state.shippingAddressData,
          shippingAddressList: action.data,
        },
      };
    case actionTypes.UPDATE_NEW_ADDRESS_SELECTION:
      return {
        ...state,
        shippingAddressData: {
          ...state.shippingAddressData,
          newAddressForm: action.data,
        },
      };
    case actionTypes.RESET_NEW_ADDRESS_SELECTION:
      return {
        ...state,
        shippingAddressData: {
          ...state.shippingAddressData,
          newAddressForm: initialState.newAddressForm,
        },
      };
    case actionTypes.UPDATE_AUTHENTICATION_MODAL_STATUS:
      return {
        ...state,
        shippingAddressData: {
          ...state.shippingAddressData,
          showModal: action.data,
        },
      };
    case actionTypes.MOVERS_UPDATE_SHIPPING_ADDRESS_SUCCESS:
      return {
        ...state,
        updateShippingAPIResponse: {
          response: action.response,
          error: false,
          msg: '',
        },
      };
    case actionTypes.MOVERS_UPDATE_SHIPPING_ADDRESS_FAILURE:
      return {
        ...state,
        updateShippingAPIResponse: {
          response: {},
          error: action.response?.error,
          msg: action.response?.msg,
        },
      };
    case actionTypes.UPDATE_SHIPPING_LIST:
      return { ...state, shippingInfoData: { ...state.shippingInfoData, shippingInfo: action.response } };
    case actionTypes.VALIDATE_CART_CHECKOUT_SUCCESS:
      return {
        ...state,
        validateCartCheckoutResponse: {
          status: true,
          response: action.response,
          error: false,
          msg: '',
        },
      };
    case actionTypes.VALIDATE_CART_CHECKOUT_FAILURE:
      return {
        ...state,
        validateCartCheckoutResponse: {
          status: false,
          response: {},
          error: action.response,
        },
      };
    case actionTypes.GET_DEFAULT_SHIPPING:
      return { ...state, getDefaultShipping: action.value };
    case actionTypes.UPDATE_LV_SUSPENDED_MOVE:
      return { ...state, lvSuspendedMove: action.value };
    default:
      return state;
  }
}

export default moversReducer;
